import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { utilCategoryFormDefault } from "@factory/form/form.default";
import {
  UtilCategoryFormRule,
  UtilCategoryFormSchema,
} from "@factory/form/form.rule";
import { useQyCreateUtilCategory } from "@factory/query/util-category.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewUtilCategory() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateUtilCategory } = useFormApiMapper();
  const { showError, showSuccess } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New UtilCategory is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addUtilCategory, isLoading: isCreating } =
    useQyCreateUtilCategory(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<UtilCategoryFormSchema>({
    defaultValues: utilCategoryFormDefault,
    resolver: zodResolver(UtilCategoryFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: UtilCategoryFormSchema) => {
    const formData = mapCreateUtilCategory(form);
    addUtilCategory(formData);
  };
  const handleValidateError = (err: FieldErrors<UtilCategoryFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
